export const validatePassword = (password = "") => {
  if (password.length < 6) {
    return "Mật khẩu phải có ít nhất 6 ký tự";
  }
  if (!/[a-z]/.test(password)) {
    return "Mật khẩu phải có ít nhất 1 chữ thường";
  }
  if (!/[A-Z]/.test(password)) {
    return "Mật khẩu phải có ít nhất 1 chữ hoa";
  }
  if (!/\d/.test(password)) {
    return "Mật khẩu phải có ít nhất 1 số";
  }
  return null;
};

const getPasswordScore = (password = "") =>
  [
    password.length >= 6,
    /[a-z]/.test(password),
    /[A-Z]/.test(password),
    /\d/.test(password),
    /[!@#$%^&*(),.?":{}|<>]/.test(password),
  ].filter(Boolean).length;

export const getPasswordStrengthColor = (password) => {
  if (!password) return "default";
  const score = getPasswordScore(password);

  if (score >= 4) return "success";
  if (score >= 3) return "warning";
  return "error";
};

export const getPasswordStrengthText = (password) => {
  if (!password) return "";
  const score = getPasswordScore(password);

  if (score >= 4) return "Mạnh";
  if (score >= 3) return "Trung bình";
  if (score >= 2) return "Yếu";
  return "Rất yếu";
};
